import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=7df7d969&scoped=true"
import script from "./resource.vue?vue&type=script&lang=js"
export * from "./resource.vue?vue&type=script&lang=js"
import style0 from "./resource.vue?vue&type=style&index=0&id=7df7d969&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df7d969",
  null
  
)

export default component.exports